import * as React from "react";
import {FormGroupProps} from "../../../common/props/FormGroupProps";
import {PlaceholderProps} from "../../../common/props/PlaceholderProps";
import {option, Option} from "ts-option";
import SelectRoles from "./SelectRoles";
import Role from "../../../../model/user/Role";
import FormGroup from "../../../../hiberUiKit/src/molecules/FormGroup/FormGroup";

type Props = FormGroupProps<string[]> & PlaceholderProps;

/**
 * Select roles form view group.
 */
export default class SelectRolesFormGroup extends React.PureComponent <Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<SelectRoles placeholder={this.props.placeholder}
							 selectedId={this.props.field.getOptionalValue()}
							 onChanged={this.onChange}
							 multi={true}
							 items={option(Role.getRoles())}/>
			</FormGroup>
		);
	}

	/**
	 * Callback on role change.
	 * @param data
	 */
	onChange(data: Option<Role[]>) {
		this.props.onChange(this.props.field.updateValue(data.map(d => d.map(u => u.value))))
	}
}
